import React, { Component } from 'react';
import './css/login.css';

class Login extends Component {
	constructor(props){
		super(props);
		//console.log("Login()");
		this.state = { 
			loginState : "", 
			scheduledMessageState: "",
			ajaxLoadingState:""
		};
	}
	componentDidMount() {
	}

	componentWillUnmount() {
	}

	unscheduledOutage(){
		document.getElementById("unscheduled-message").innerHTML = window.l10n[window.locale]["login.unscheduled.message"];
		this.setState({loginState: "unscheduled"});
	}	
	
	doLogin(evt){
	}

	render() {
		var t = this;
		return (
		<div id="login-container" className={this.state.loginState + " " + this.state.scheduledMessageState}>
		<div className={"ajax-spinner-lightbox " + this.state.ajaxLoadingState } />
		<div className="innerContainer">
			<div className="login-caption">
				{ window.l10n[window.locale]["login.logintoyouraccount"] }
			</div>

			<input type="text" className="login-inp login-inp1" id="id-vin" placeholder={ window.l10n[window.locale]["login.vinno"] } />
			<input type="text" className="login-inp login-inp2" id="id-account-number" placeholder={ window.l10n[window.locale]["login.accountnumber"] } />

			<button type="button" className="login-btn" id="id-btn-sign-in" onClick={
				(e)=>{
					console.log("Logging in...");

					var vin=document.getElementById("id-vin").value.trim();
					var acct=document.getElementById("id-account-number").value.trim();
					if ("" === vin || "" === acct) return;

					var xhr = new XMLHttpRequest();
					xhr.onreadystatechange = function() {
						if (this.readyState === 4){
							if (this.status === 200) {
								console.log("responseText: " + this.responseText);
								var responseJson = "";
								if (this.responseText) responseJson = JSON.parse(this.responseText);
								console.log("JSON: %o", responseJson);
								console.log("hdr X-OPTA-AUTH:" + this.getResponseHeader("X-OPTA-AUTH"));
								if (this.getResponseHeader("X-OPTA-AUTH")){
									var optaToken = responseJson["OPTATOKEN"];
									var clientLanguage = window.locale;
									if (responseJson["LANG"]){
										var lang = responseJson["LANG"].trim().toLowerCase();
										if ( lang.match(/^f/gi)){
											clientLanguage = "FR";
										} else if ( lang.match(/^e/gi)){
											clientLanguage = "EN";
										}
									}
									console.log("AuthToken:" + optaToken);
									t.setState({loginState: "", ajaxLoadingState: ""});
									window.location.href = "lessee-" + clientLanguage + "?ol=" + optaToken;
								} else {
									t.setState({ajaxLoadingState: ""});
									t.props.ctx.doLogout();
								}
							} else {
								console.log("invalid credentials");
								window.optatoken = "";
								t.setState({loginState: "failed-login", ajaxLoadingState: ""});
								t.props.ctx.doLogout();
							}
						}
					};

					xhr.open('post', window.AppConfig["url-authenticate"], true);
					xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
					this.setState({ajaxLoadingState: "loading"});
					xhr.send( JSON.stringify({
						vin : btoa(vin),
						acct: btoa(acct),
						isLessee : true,
						isAcctAdmin : false						
					}));
				}
			}>{ window.l10n[window.locale]["login.signin"] }</button>

			<div className="login-text">
				{ window.l10n[window.locale]["login.caption1"] }
			</div>
			<div className="login-failed-container">
				<div className="exclam"></div>
				<div className="l1">{ window.l10n[window.locale]["login.fail.line1"] }</div>
			</div>
			<div className="login-unscheduled-container">
				<div className="exclam"></div>
				<div id="unscheduled-message" className="l1"></div>
			</div>
		</div>
		</div>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/login.js